<lum-ui-modal
  [modalTitle]="mode === 'Create' ? 'New Channel' : 'Edit Channel'"
  class="channel-form__modal-wrapper"
>
  <div header-close></div>
  <div body>
    <div
      class="overlay"
      lumAppLoader
      [loading]="(loading$ | async) || false"
      [classes]="'loading blur'"
    ></div>

    <form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="">Channel</label>
            <input type="text" class="text lum-input" formControlName="label" />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="">Warehouse Group</label>
            <lum-location-warehouse-group-control
              formControlName="warehouseGroupId"
            ></lum-location-warehouse-group-control>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Tags</label>
            <lum-tag-autocomplete-chip
              [formArray]="tagIds"
            ></lum-tag-autocomplete-chip>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="">Description</label>
            <textarea
              class="text lum-input"
              formControlName="description"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <div class="form-group">
            <mat-slide-toggle
              title="PULL Orders"
              color="primary"
              formControlName="pullOrdersFromOms"
            ></mat-slide-toggle>
            PULL SALES ORDERS
          </div>
          <ng-container *ngIf="shouldPullOrders">
            <div class="row">
              <div class="col-6">
                <div class="form-group mb-0">
                  <label for="">Pull Orders From</label>
                  <lum-app-integration-account-control
                    (onAppAccountSelect)="onAppAccountSelected($event)"
                    formControlName="appIntegrationAccountId"
                  ></lum-app-integration-account-control>
                  <span *ngIf="ediWebhookUrl" class="subtitle"
                    >Webhook URL: {{ ediWebhookUrl }}</span
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-group" *ngIf="showOmsStoresDropdown">
                  <label for="">OMS Store</label>
                  <lum-app-integration-account-oms-store-control
                    [appIntegrationAccountId]="selectedAppIntegrationAccountId"
                    [excludeUsedOmsStoreIds]="true"
                    formControlName="omsStoreId"
                  ></lum-app-integration-account-oms-store-control>
                </div>
              </div>
            </div>
            <div class="row mb-3" *ngIf="showChannelFilters">
              <div class="col-12">
                <fieldset>
                  <legend>
                    Incoming Order Filters
                    <small
                      >If at least one filter is set, then only orders that matches
                      the filter/s will be attached to this channel.</small
                    >
                  </legend>
                  <lum-channel-form-filters
                    [formData]="formData"
                  ></lum-channel-form-filters>
                </fieldset>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <section *ngIf="shouldPullOrders && showPushOrders">
        <div class="row mt-3">
          <div class="col-6 form-group">
            <span>
              <mat-slide-toggle
                title="PULL Orders"
                color="primary"
                formControlName="pushOrdersToOms"
              ></mat-slide-toggle>
              Push Orders to Integration
            </span>
          </div>
          <div class="col-6" formGroupName="pushOrdersToOmsOptions">
            <span class="ml-3" *ngIf="showPushStocksToggle">
              <mat-slide-toggle
                title="Push Stock"
                color="primary"
                formControlName="pushStock"
              ></mat-slide-toggle>
              Push Stock
            </span>
          </div>
        </div>
        <div class="row" *ngIf="shouldPushOrders">
          <div class="col-6">
            <div class="form-group">
              <label for="">Push Orders To Integration</label>
              <lum-app-integration-account-control
                [appAccountType]="ediPushOrderToOmsAppTypes"
                (onAppAccountSelect)="onPushOrderAppAccountSelected($event)"
                formControlName="pushOrderAppIntegrationAccountId"
              ></lum-app-integration-account-control>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group" *ngIf="showPushOrderOmsStoresDropdown">
              <label for="">OMS Store</label>
              <lum-app-integration-account-oms-store-control
                [appIntegrationAccountId]="selectedPushOrderAppIntegrationAccountId"
                [excludeUsedOmsStoreIds]="true"
                formControlName="pushOrderOmsStoreId"
              ></lum-app-integration-account-oms-store-control>
            </div>
          </div>
        </div>
        <ng-container
          *ngIf="shouldPushOrders"
          formGroupName="pushOrdersToOmsOptions"
        >
          <div class="row">
            <div class="col-6">
              <div class="form-group mb-0">
                <label for=""
                  >Automatically Push Posted Order After x Minutes</label
                >
                <input
                  type="number"
                  class="lum-input"
                  formControlName="autoPushOrderAfterMinutes"
                />
              </div>
            </div>

            <div class="col-6" *ngIf="shouldSetShppingMethod">
              <div class="form-group mb-0">
                <label for="">Default Push Order Shipping Method</label>
                <lum-app-integration-account-shipping-method-control
                  [appIntegrationAccountId]="
                    selectedPushOrderAppIntegrationAccountId
                  "
                  [excludeUsedOmsShippingMethodIds]="true"
                  formControlName="omsShippingMethodId"
                ></lum-app-integration-account-shipping-method-control>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="showPushOrderCustomFields">
            <div class="col-12">
              <fieldset>
                <legend>
                  Push Order Custom Fields
                  <small
                    >Set custom order properties to be included when pushing order
                    to third-party OMS.</small
                  >
                </legend>
                <lum-channel-form-push-custom-fields
                  [formGroup]="pushOrdersToOmsOptions"
                ></lum-channel-form-push-custom-fields>
              </fieldset>
            </div>
          </div>
        </ng-container>
      </section>

      <ng-container *ngIf="showGetProductsToggle">
        <div class="row mt-3">
          <div class="col-12 form-group">
            <span>
              <mat-slide-toggle
                title="GET PRODUCTS"
                color="primary"
                formControlName="getProductsEnabled"
              ></mat-slide-toggle>
              GET PRODUCTS
            </span>
            <span class="ml-3" *ngIf="shouldGetProducts">
              <mat-slide-toggle
                title="Push Stock"
                color="primary"
                formControlName="pushInventoryEnabled"
              ></mat-slide-toggle>
              Push Stock to Integration
            </span>
            <span class="ml-3" *ngIf="shouldGetProducts">
              <mat-slide-toggle
                title="PUSH STOCKS"
                color="primary"
                formControlName="includeIncomingStocksEnabled"
              ></mat-slide-toggle>
              Include Incoming Stocks as Sellable
            </span>
          </div>
        </div>
        <div class="row" *ngIf="shouldGetProducts">
          <div class="col-6">
            <div class="form-group">
              <label for="">Get Products From</label>
              <mat-select formControlName="storeType" class="lum-input">
                <mat-option *ngFor="let store of storeTypesList" [value]="store.id">
                  {{ store.storeType }}
                </mat-option>
              </mat-select>
            </div>
          </div>
          <div class="col-6">
            <div class="form-group" *ngIf="showGetProductsOmsDropdown">
              <label for="">Get Products from OMS</label>
              <lum-app-integration-account-control
                [appAccountType]="appAccountType.TRACKSTAR"
                (onAppAccountSelect)="onAppAccountSelect($event)"
                formControlName="getProductsAppIntegrationAccountId"
              ></lum-app-integration-account-control>
            </div>
          </div>
          <div
            class="col-6"
            *ngIf="
              shouldGetProducts && selectedStoreType === storeTypeConstant.TRACKSTAR
            "
          >
            <div class="form-group" [formGroup]="credentials">
              <label for="">Warehouse</label>
              <input
                formControlName="warehouse_id"
                type="text"
                class="lum-input"
                matInput
              />
            </div>
            <mat-error
              *ngIf="submitted && credentials.get('warehouse_id')?.invalid"
            >
              <small class="text-red"> This field is required </small>
            </mat-error>
          </div>
          <div class="col-12">
            <div
              class="form-group"
              *ngIf="
                shouldGetProducts &&
                selectedStoreType === storeTypeConstant.TRACKSTAR
              "
            >
              <span class="ml-3">
                <mat-slide-toggle
                  title="PULL STOCKS"
                  color="primary"
                  formControlName="pullStocksEnabled"
                ></mat-slide-toggle>
                Pull Stock
              </span>
              <span class="ml-3">
                <mat-slide-toggle
                  title="PULL Shipments"
                  color="primary"
                  formControlName="pullShipmentsEnabled"
                ></mat-slide-toggle>
                Pull Shipments
              </span>
            </div>
          </div>
        </div>
        <div
          class="row store-credentials mb-3"
          *ngIf="shouldGetProducts && selectedStoreType > 0"
        >
          <div class="col-12">
            <div [ngSwitch]="selectedStoreType">
              <ng-container *ngSwitchCase="storeTypeConstant.SHOPIFY">
                <lum-channel-form-shopify-creds
                  [formData]="credentials"
                ></lum-channel-form-shopify-creds>
              </ng-container>
              <ng-container *ngSwitchCase="storeTypeConstant.AMAZON">
                <lum-channel-form-amazon-creds
                  [formData]="credentials"
                ></lum-channel-form-amazon-creds>
              </ng-container>
              <ng-container *ngSwitchCase="storeTypeConstant.WOOCOMMERCE">
                <lum-channel-form-woocommerce-creds
                  [formData]="credentials"
                ></lum-channel-form-woocommerce-creds>
              </ng-container>
              <ng-container *ngSwitchCase="storeTypeConstant.API2CART">
                <lum-channel-form-api2cart-creds
                  [formData]="credentials"
                ></lum-channel-form-api2cart-creds>
              </ng-container>
              <ng-container *ngSwitchCase="storeTypeConstant.HUBSPOT">
                <lum-channel-form-hubspot-creds
                  [formData]="credentials"
                ></lum-channel-form-hubspot-creds>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>

      <fieldset class="mt-3">
        <legend>Channel Fees</legend>
        <lum-channel-form-fees [formData]="formData"></lum-channel-form-fees>
      </fieldset>

      <div class="row mt-5">
        <div class="col-12 action-row">
          <button
            type="button"
            class="lum-button lum-button--secondary mx-3"
            mat-button
            (click)="onClose()"
            [disabled]="loading$ | async"
          >
            <lum-ui-icon
              class="mr-2-5"
              icon="close-circle"
              color="#5563D6"
              width="23"
              height="23"
            ></lum-ui-icon>
            Close
          </button>

          <button
            type="submit"
            class="lum-button"
            mat-button
            [disabled]="loading$ | async"
          >
            <lum-ui-icon
              class="mr-2-5"
              icon="content-save"
              color="#FFF"
              width="23"
              height="23"
            ></lum-ui-icon>
            Save
          </button>
        </div>
      </div>
    </form>
  </div>
</lum-ui-modal>
